import React from 'react'
import { Typography, TypographyProps } from './Typography'

export type TextProps = Omit<TypographyProps, 'variant'> & {
  /**
   * テキストのサイズ
   * - "body": 標準サイズ (16px)
   * - "body-s": 中間サイズ (14px)
   * - "small": 小さいサイズ (12.8px)
   */
  size?: 'body' | 'body-s' | 'small'
}

/**
 * テキスト要素のコンポーネント
 * Typographyコンポーネントのラッパーとして、より直感的なAPIを提供します
 */
export const Text: React.FC<TextProps> = ({
  size = 'body',
  ...props
}) => {
  const variant = size as TypographyProps['variant']

  return (
    <Typography
      variant={variant}
      {...props}
    />
  )
}
